/**
 * Une capacité de l'agent sur une ligne : icône, nom, état en quelques mots.
 * Le détail (liste, bouton Ajouter) ne s'ouvre qu'au clic. Une seule ouverte
 * à la fois : l'onglet Actions tient sur un écran, comme chez Retell ou
 * ElevenLabs.
 */
import { ChevronDown, type LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function CapaciteRow({ icone: Icone, titre, etat, ouvert, onToggle, attention, children }: {
  icone: LucideIcon; titre: string; etat: string; ouvert: boolean; onToggle: () => void; attention?: boolean; children: ReactNode
}) {
  return (
    <div className={cn('rounded-xl border bg-white dark:bg-slate-900 transition-colors', ouvert ? 'border-slate-300 dark:border-slate-700' : 'border-slate-200 dark:border-slate-800')}>
      <button type="button" onClick={onToggle} className="w-full flex items-center gap-3 px-4 py-3 text-left">
        <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300"><Icone className="h-[18px] w-[18px]" /></span>
        <span className="min-w-0 flex-1">
          <span className="block text-sm font-medium text-slate-900 dark:text-white">{titre}</span>
          <span className={cn('block text-xs truncate', attention ? 'text-amber-600 dark:text-amber-300' : 'text-slate-500 dark:text-slate-400')}>{etat}</span>
        </span>
        <ChevronDown className={cn('h-4 w-4 shrink-0 text-slate-400 transition-transform', ouvert && 'rotate-180')} />
      </button>
      {ouvert && <div className="px-4 pb-4 pt-1 border-t border-slate-100 dark:border-slate-800">{children}</div>}
    </div>
  )
}
